import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "../components/Sidebar/Sidebar";
import Navbar from "../components/Navbar/Navbar";

import "./MainLayout.css";
import { IMAGES, ICONS } from "../constants/constants";
import { Outlet } from "react-router-dom"; // Import Outlet

const MainLayout = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const handleSidebarToggle = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <>
      <Container fluid className="dashboard">
        <Row className="mainDashboardRow">
          <Col xs={2} md={2} className="bg-white border logoDiv">
            <img src={ICONS.logoIcon} alt="Search" className="logo" />
          </Col>
          <Col xs={10} md={10} className="bg-white text-black">
            <Navbar onSidebarToggle={handleSidebarToggle} />
          </Col>
          {/* Sidebar */}
          <Col
            xs={isSidebarCollapsed ? 1 : 2}
            md={isSidebarCollapsed ? 1 : 2}
            className="bg-white sidebar-col"
          >
            <Sidebar isCollapsed={isSidebarCollapsed} />
          </Col>

          <Col
            xs={isSidebarCollapsed ? 11 : 10}
            md={isSidebarCollapsed ? 11 : 10}
            className="mt-2 content-col"
          >
            <main>
              <Outlet />
            </main>
          </Col>
        </Row>
      </Container>
      <img src={ICONS.sidebarIcon} className="sidebar-icon" />
    </>
  );
};

export default MainLayout;
